import { render, staticRenderFns } from "./sub_bottom.vue?vue&type=template&id=5c3fea8b&scoped=true&"
import script from "./sub_bottom.vue?vue&type=script&lang=js&"
export * from "./sub_bottom.vue?vue&type=script&lang=js&"
import style0 from "./sub_bottom.vue?vue&type=style&index=0&id=5c3fea8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3fea8b",
  null
  
)

export default component.exports